import { EMPTY_TRIAL_ASSIST_PRO } from "@/lib/constants/subscribe-assist-pro";
import type { UserContext } from "@/lib/interfaces/user-context";

export const createInitialUser = (): UserContext => ({
  apelido: "",
  codUsuario: 0,
  codClinica: 0,
  codPerfil: 0,
  bloqueado: false,
  statusDocumentosCaf: null,
  pj: false,
  ativo: false,
  nome: "",
  sobrenome: "",
  cpf: "",
  altaTaxaCancelamento: false,
  zendeskSessionToken: "",
  sub: "",
  codParceiroPortoSeguro: false,
  modalidadesDeParceria: [],
  codConselhoClasse: "",
  ramalTroncoNormalizado: "",
  funcionalidadesContratadas: [],
  pacotesServicos: [],
  especialidades: [],
  possivelDataFimTrialAssistPro: EMPTY_TRIAL_ASSIST_PRO,
  acoesPromocionais: [],
  possuiSitePersonalizado: false,
  possuiContaRecebedora: false,
  possuiAgendaAtiva: false,
  possuiCartaoPendente: false,
  fluxosPendentes: [],
});
